<template>
  <div>
    <div class="card-header">全部课卡（共 {{count}} 张）</div>
    <div
      v-for="item in list"
      :key="item.id"
      :class="`card${item.is_expired ? ' expired-color' : ''}`"
      :style="`box-shadow: 0 15px 10px -15px ${item.color}`"
    >
      <el-image v-if="item.background" :src="item.background" :lazy="true" class="img">
        <div
          class="card-placeholder"
          slot="placeholder"
          :style="`background: ${item.color}`"
        >
        </div>
        <div slot="error" class="card-placeholder" :style="`background: ${item.color}`"></div>
      </el-image>
      <div class="content">
        <div class="flex-justify-between">
          <div class="studio-name-box">
            <div class="studio-name">ZAHACLUB</div>
            <div class="type-name">{{item.card_type_name}}</div>
          </div>
          <span
            v-if="usedCardId === item.id"
            class="used"
            :style="`color: ${item.color}`"
          >
            优先使用
          </span>
        </div>

        <div>
          <div class="flex-box">
            <div class="card-name">{{item.card_name}}</div>
            <template v-if="item.is_expired">
              <template v-if="item.is_number_limit">
                <div class="card-tip">
                  {{item.expire_number > 0 ? '已过期' : '已用完'}}
                </div>
              </template>
              <div v-else class="card-tip">已过期</div>
            </template>
            <div v-else-if="!item.expire_time" class="card-tip">未开卡</div>
          </div>
          <div v-if="item.is_number_limit" class="expire-number">剩余 {{item.expire_number | toYuan }} 次</div>
        </div>

        <div class="expire-date-box expire-number">
          <div v-if="item.expire_time">有效期至：{{ item.expire_time | timeToYmdHi }}</div>
          <div v-else></div>
          <div v-if="item.card_number">卡号：{{item.card_number}}</div>
          <div v-else class="slogan">No.{{item.id}}</div>
        </div>
      </div>
    </div>

    <div v-if="count" class="pagination-box">
      <el-pagination
        :background="true"
        :current-page.sync="page"
        :page-size="size"
        layout="total, prev, pager, next, jumper"
        :total="count"
        @size-change="handlePageChange"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import scrollTo from "@/utils/scroll-to";
import { index } from "@/api/card";

export default {
  props: {
    studentId: Number,
    usedCardId: Number,
  },
  data: () => ({
    list: [],
    count: 0,
    page: 1,
    size: 10,
  }),
  methods: {
    async getList() {
      if (!this.studentId) return;

      const { isError, data } = await index({
        student_ids: [this.studentId],
        is_with_color: 1,
        page: this.page,
        size: this.size,
      });
      if (isError) return;

      this.list = data.list;
      this.count = data.count;
    },
    handlePageChange() {
      this.getList();
      scrollTo(0, 350);
    },
  },
  beforeMount() {
    this.getList();
  },
};
</script>

<style src="./index.css" scoped/>
<style src="./index-phone.css" scoped/>
